import {Loader, LoaderOptions} from 'google-maps'

// Google
window.google = null;

new Loader('AIzaSyBDCogWLcbcSzz7GZgchieHlYyn9mVZeS4', {
	libraries: ['places']
}).load()
.then(function (google) {
	google = google;
});
